import { Box } from '@mui/material'
import { useContext, useEffect } from 'react'
import { ContentHead } from '../components/common/ContentHead'
import { EmptyData } from '../components/common/EmptyData'
import { SearchWithKeypress } from '../components/common/SearchWithKeypress'
import DepartmentListing from '../components/departments'
import DepartmentFilters from '../components/departments/DepartmentFilters'
import DepartmentModal from '../components/departments/DepartmentModal'
import { ADD_DEPARTMENT, DEPARTMENTS } from '../constants'
import { AppContext } from '../context'
import { ActionType } from '../context/AppContextReducer'
import { useDepartments } from '../hooks/useDepartments'
import { CardBox } from '../theme/styleComponents'
import { flexCenter } from '../theme/styleConstants'

// others
// components
const DepartmentsContainer = () => {
  const { departments, pagination, loading, refetch } = useDepartments({ listingPage: true })
  const { isOpen, dispatch } = useContext(AppContext)
  const isEmpty = !loading && departments.length === 0
  const searchText = 'Search Department'

  const handleClose = () => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })

  useEffect(() => {
    dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: pagination?.page || 1 })
    dispatch({ type: ActionType.SET_TOTAL_PAGE_COUNT, totalPageCount: pagination?.totalPages || 1 })
  }, [dispatch, pagination?.page, pagination?.totalPages])

  return (
    <CardBox marginTop={3}>
      <ContentHead title={DEPARTMENTS} buttonText={ADD_DEPARTMENT} />

      <Box display={'flex'} flex={1} justifyContent={'space-between'} alignItems={'center'} m={2}>
        <SearchWithKeypress searchPlaceholder={searchText} />
        <DepartmentFilters />
      </Box>

      {isEmpty ? (
        <Box sx={{ ...flexCenter, height: 'calc(100vh - 400px)' }}>
          <EmptyData title={'No Departments!'} />
        </Box>
      ) : (
        <DepartmentListing departments={departments} loading={loading} refetch={refetch} />
      )}
      <DepartmentModal isOpen={isOpen} handleClose={handleClose} refetch={refetch} />
    </CardBox>
  )
}

export default DepartmentsContainer
